<template>
  <figure class="wrapper m-d">
    <div id="whac-a-carrot" class="advergaming-minigame whac-a-carrot">
      <Counter :score="score" />
      <Transition @leave="onOverlayLeave">
        <GameOverlay v-if="!hideOverlay" mobile="tap" desktop="mouse" />
      </Transition>
    </div>

    <Caption :content="content" />
  </figure>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, PropType } from 'vue'
import { useStore } from '@nanostores/vue'

import { WhacACarrot } from '@/components/advergaming/WhacACarrot'
import Counter from '@/components/advergaming/Counter.vue'
import Caption from '@/components/advergaming/Caption.vue'
import GameOverlay from '@/components/advergaming/GameOverlay.vue'
import { useAdvergamingStore } from '@/stores/advergaming'
import { AdvergamingCaption } from '@/components/advergaming/Caption.vue'
import gsap from 'gsap'

defineProps({
  content: {
    type: Object as PropType<AdvergamingCaption>,
    required: true,
  },
})

const game = new WhacACarrot({
  id: 'whac-a-carrot',
  store: useAdvergamingStore(),
})

const hideOverlay = useStore(game.store.$interactedWith)
const onOverlayLeave = (el: Element, done: () => void) => {
  gsap.to(el, {
    opacity: 0,
    scale: 1.1,
    duration: 0.15,
    onComplete: done,
  })
}

const score = useStore(game.store.$score)

onMounted(() => {
  game.init({
    container: document.querySelector('#whac-a-carrot')!,
    renderer: {
      antialias: true,
    },
  })
})

onBeforeUnmount(() => {
  game?.dispose()
})
</script>

<style lang="scss" scoped>
.whac-a-carrot {
  &.has-pointer {
    cursor: pointer;
  }

  @include mq($until: m) {
    /* stylelint-disable declaration-no-important */
    height: auto !important;
    aspect-ratio: 1 !important;
    /* stylelint-enable declaration-no-important */
  }
}

.advergaming-caption {
  margin-top: 0;
}
</style>
